import React from 'react';
import { Alert, Input, Button, Spin, Icon } from 'antd';

import SearchUser from '../../SearchUser';
import SelectGroup from './SelectGroup';

import styles from './styles.module.scss';

const EMAIL_REGEXP = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

function validateEmail (email = '') {
  return `${email}`.match(EMAIL_REGEXP);
}

export const UserFormRender = ({
  user, name, group, matricule, setUser, setGroup, setMatricule, save, saving,
  email, setEmail, register, registering, success, errorMatricule, errorGroup, pristine,
}) => (
  <div>
    {!user.id &&
    (registering
      ? <div className={styles.loading}><Spin /></div>
      : (
        <div>
          <p>Saisir l'email de l'agent à créer&nbsp;:</p>
          <SearchUser
            onSelect={setUser}
            onSearch={setEmail}
            inGroups={['!staff']}
            placeholder="Email de l'agent"
          />
          {validateEmail(email) && (
            <Button
              type="primary"
              onClick={register}
            >
              Créer l'utilisateur
            </Button>
          )}
        </div>
      )
    )}
    {user.id && (
      <form
        onSubmit={save}
        className={styles.form}
      >
        <p>{name}</p>
        <fieldset>
          <label>
            Code poste :
            <Input
              value={matricule}
              placeholder="12345678"
              onChange={setMatricule}
            />
          </label>
        </fieldset>
        {errorMatricule && (
          <Alert
            type="warning"
            message="Le code poste existe déjà."
            showIcon
          />
        )}
        <fieldset>
          <SelectGroup
            user={user}
            value={group}
            onChange={setGroup}
          />
        </fieldset>
        {errorGroup && (
          <Alert
            type="warning"
            message="Le groupe est invalide"
            showIcon
          />
        )}
        <fieldset className={styles.form__button}>
          <Button
            type="primary"
            onClick={save}
            disabled={pristine || saving || errorMatricule || errorGroup}
            ghost={success}
          >
            {success ? 'Modifications sauvegardées' : 'Enregistrer'}
            {success && <Icon type="check" />}
          </Button>
        </fieldset>
      </form>
    )}
  </div>
);

export default UserFormRender;



// WEBPACK FOOTER //
// ./src/components/Admin/UsersManagement/UserEdit/Form/render.js